import { useState } from 'react';
import { FloatButton } from 'antd';
import { BugOutlined } from '@ant-design/icons';
import ReportIncidentModal from './ReportIncidentModal';

// FloatButton global accesible desde cualquier página autenticada. Montado
// en LayoutMain adentro del ErrorCaptureProvider para que el modal pueda
// consumir el buffer de errores JS.

const ReportIncidentFloatButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <FloatButton
        icon={<BugOutlined />}
        tooltip="Reportar un problema o sugerencia"
        type="primary"
        style={{ right: 24, bottom: 24 }}
        onClick={() => setOpen(true)}
      />
      <ReportIncidentModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default ReportIncidentFloatButton;
